module.exports = {
  siteMetadata: {
    title: 'Gatsby Default Starter',
	},
	proxy: {
		prefix: "/server",
		url: "http://localhost:3001",
	},
	plugins: [
		'gatsby-plugin-styled-components',
		'gatsby-plugin-react-helmet',
		{
			resolve: `gatsby-plugin-sass`,
			options: {
				precision: 8,
			},
		},
	],
};



// WEBPACK FOOTER //
// ./gatsby-config.js